import React from "react";
import { Modal} from "antd";
import { URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString } from "../../frameworks/Util";
import _ from "lodash";

export default function ReceivingWeightLogModal(props) {
  const { open, onClose, target, direction } = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();
  const columns = [
    {
      title: 'วัน - เวลา',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value),
      width: '40%',
    },
    {
      title: 'น้ำหนัก',
      dataIndex: 'weight',
      key: 'weight',      
    },
    {
      title: 'ผู้บันทึก',
      dataIndex: 'created_by_name',
      key: 'created_by_name',      
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  return(
    <Modal
      title={<center>{direction === 'in' ? "ประวัติน้ำหนักเข้า" : "ประวัติน้ำหนักออก"}</center>}
      open={open}
      onCancel={onClose}
      width={550}
      destroyOnClose
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TRUCK.TRUCK_TRANSACTION_WEIGHT}
        params={{truck_transaction : _.get(target, 'id' , ), direction : direction}}
      />
    </Modal>
  )
}